<template>
  <div>
    <div class="card card-custom card-sticky" v-if="!mostrarDetalleFicha">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label cursor-pointer">
            <span class="label label-xl label-dot label-success mr-2"></span> Turno 3 - Mesa <i class="mr-2"></i>
            <small v-if="ui.estaCargandoDatos" class="">Cargando datos de la ficha...</small>
            <small v-else-if="auth.mensajeNoAutorizadoEdicionTurno" class="text-danger">{{ auth.mensajeNoAutorizadoEdicionTurno }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <a href="#" class="btn btn-sm btn-light font-weight-bold" @click.prevent="doCargarFicha()"><i class="fa p-0 fa-sync" :class="[ui.estaCargandoDatos ? 'fa-spin ' : '']"></i></a>
        </div>
      </div>
    </div>
    <div class="card card-custom card-sticky" v-if="mostrarDetalleFicha">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label cursor-pointer" @click.prevent="$emit('update:expandirContenido', !expandirContenido)">
            <span class="label label-xl label-dot label-success mr-2"></span> Turno 3 - Mesa <i class="mr-2"></i>
            <small class="">{{ auth.fechaInicioTurno | time }} - {{ auth.fechaFinTurno | time }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <span v-if="auth.puedeCambiarEstadoFinalizado == true">
            <a href="#" v-if="finalizado == true" class="btn btn-sm btn-light-danger font-weight-bold mr-2" v-b-tooltip.left title="Presione para desbloquear" @click.prevent="doToggleFinalizado()"> <i class="fa fa-lock"></i>Finalizado</a>
            <a href="#" v-if="finalizado == false" class="btn btn-sm btn-light font-weight-bold mr-2" v-b-tooltip.left title="Presione para bloquear" @click.prevent="doToggleFinalizado()"> <i class="fa fa-unlock-alt"></i>Desbloquear</a>
          </span>
          <span v-if="auth.puedeCambiarEstadoFinalizado == false">
            <a href="#" v-if="finalizado == true" class="btn btn-sm btn-light-danger font-weight-bold mr-2"> <i class="fa fa-lock"></i>Finalizado</a>
          </span>

          <a href="#" class="btn btn-sm font-weight-bold mr-2" :class="isDirty ? 'btn-success' : 'btn-light-success'" @click.prevent="doGuardado()"><i class="fa" :class="[ui.estaGuardando ? 'fa-spinner fa-spin p-0 fa-align-center mr-1' : 'fa-save']"></i> Guardar cambios</a>

          <a href="#" class="btn btn-sm btn-light-warning font-weight-bold" @click.prevent="$emit('update:expandirContenido', !expandirContenido)"><i class="fa p-0" :class="[expandirContenido ? 'fa-chevron-up' : 'fa-chevron-down']"></i></a>
        </div>
      </div>
      <div class="card-body" v-show="expandirContenido">
        <form class="form" id="frm-mesa-turno-3">
          <div class="row">
            <div class="col-xl-2"></div>
            <div class="col-xl-8">

              <!-- III. INICIO DEL ESCRUTINIO (CONTEO DE VOTOS) -->
              <div class="my-5">
                <h3 class=" text-dark font-weight-bold mb-10">III. Inicio del escrutinio (conteo de votos)</h3>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">3.1. Número de mesa de votación:</label>
                  <div :class="ui.colRightClass">
                    <input type="text" class="form-control" v-model="actual.t3NumeroMesa" placeholder="Número de mesa..." />
                  </div>
                </div>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">3.2. ¿El miembro de mesa realizó el conteo de huellas o firmas para determinar cuántos electores votaron y lo registró en el acta de sufragio?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3ConteoFirmasOHuellasCoincideActaSufragio = true" class="btn" :class="[actual.t3ConteoFirmasOHuellasCoincideActaSufragio === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3ConteoFirmasOHuellasCoincideActaSufragio = false" class="btn" :class="[actual.t3ConteoFirmasOHuellasCoincideActaSufragio === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t3ConteoFirmasOHuellasCoincideActaSufragio === false" v-model="actual.t3ConteoFirmasOHuellasCoincideActaSufragioDetalle" class="form-control mt-2" type="text" placeholder="Especifique..." required></textarea>
                  </div>
                </div>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">3.3. ¿Se verificó que el ánfora de votación estuviera sellada y en buen estado antes de abrirla?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3AnforaFueVerificadaAntesApertura = true" class="btn" :class="[actual.t3AnforaFueVerificadaAntesApertura === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3AnforaFueVerificadaAntesApertura = false" class="btn" :class="[actual.t3AnforaFueVerificadaAntesApertura === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t3AnforaFueVerificadaAntesApertura === false" v-model="actual.t3AnforaFueVerificadaAntesAperturaDetalle" class="form-control mt-2" type="text" placeholder="Especifique..." required></textarea>
                  </div>
                </div>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">3.4. ¿El ánfora de votación fue abierta en presencia de los asistentes?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3AnforaSeAbrioEnPresenciaAsistentes = true" class="btn" :class="[actual.t3AnforaSeAbrioEnPresenciaAsistentes === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3AnforaSeAbrioEnPresenciaAsistentes = false" class="btn" :class="[actual.t3AnforaSeAbrioEnPresenciaAsistentes === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t3AnforaSeAbrioEnPresenciaAsistentes === false" v-model="actual.t3AnforaSeAbrioEnPresenciaAsistentesDetalle" class="form-control mt-2" type="text" placeholder="Especifique..." required></textarea>
                  </div>
                </div>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">3.5. ¿Las cédulas de votación fueron contadas y registradas en las actas electorales conforme al procedimiento establecido?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3ConteoCedulasCorrecto = true" class="btn" :class="[actual.t3ConteoCedulasCorrecto === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3ConteoCedulasCorrecto = false" class="btn" :class="[actual.t3ConteoCedulasCorrecto === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t3ConteoCedulasCorrecto === false" v-model="actual.t3ConteoCedulasCorrectoDetalle" class="form-control mt-2" type="text" placeholder="Especifique..." required></textarea>
                  </div>
                </div>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">3.6. ¿Los votos fueron asignados correctamente a las organizaciones políticas y candidatos correspondientes en las actas electorales?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3AsignacionVotosCorrectaActas = true" class="btn" :class="[actual.t3AsignacionVotosCorrectaActas === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3AsignacionVotosCorrectaActas = false" class="btn" :class="[actual.t3AsignacionVotosCorrectaActas === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t3AsignacionVotosCorrectaActas === false" v-model="actual.t3AsignacionVotosCorrectaActasDetalle" class="form-control mt-2" type="text" placeholder="Especifique..." required></textarea>
                  </div>
                </div>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">3.7. ¿Todos los miembros de mesa manifestaron su conformidad con las cifras consignadas en las actas electorales?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3MiembrosMesaConformesCifrasActa = true" class="btn" :class="[actual.t3MiembrosMesaConformesCifrasActa === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3MiembrosMesaConformesCifrasActa = false" class="btn" :class="[actual.t3MiembrosMesaConformesCifrasActa === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t3MiembrosMesaConformesCifrasActa === false" v-model="actual.t3MiembrosMesaConformesCifrasActaDetalle" class="form-control mt-2" type="text" placeholder="Especifique..." required></textarea>
                  </div>
                </div>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">3.8. ¿Se publicó el cartel de resultados con el total de votos en la parte externa del aula?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3CartelResultadosPublicadoAfueraAula = true" class="btn" :class="[actual.t3CartelResultadosPublicadoAfueraAula === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3CartelResultadosPublicadoAfueraAula = false" class="btn" :class="[actual.t3CartelResultadosPublicadoAfueraAula === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t3CartelResultadosPublicadoAfueraAula === false" v-model="actual.t3CartelResultadosPublicadoAfueraAulaDetalle" class="form-control mt-2" type="text" placeholder="Especifique..." required></textarea>
                  </div>
                </div>
              </div>

              <!-- IV. INCIDENCIAS DURANTE EL ESCRUTINIO -->
              <div class="my-5">
                <h3 class=" text-dark font-weight-bold mb-10">IV. Incidencias durante el escrutinio</h3>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">4.1. ¿Se presentó alguna impugnación durante el escrutinio?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3SePresentoImpugnacion = true" class="btn" :class="[actual.t3SePresentoImpugnacion === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3SePresentoImpugnacion = false" class="btn" :class="[actual.t3SePresentoImpugnacion === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t3SePresentoImpugnacion === true" v-model="actual.t3SePresentoImpugnacionDetalle" class="form-control mt-2" type="text" placeholder="Especifique..." required></textarea>
                  </div>
                </div>

                <div class="form-group row" v-if="actual.t3SePresentoImpugnacion === true">
                  <label :class="ui.colLeftClass">4.2. ¿Quién presentó la impugnación?</label>
                  <div :class="ui.colRightClass">
                    <label class="checkbox checkbox-primary checkbox-lg"><input type="checkbox" v-model="actual.t3QuienPresentoImpugnacionMiembroMesa" :value="true" /><span class="mr-2"></span>Miembro de mesa</label>
                    <label class="checkbox checkbox-primary checkbox-lg"><input type="checkbox" v-model="actual.t3QuienPresentoImpugnacionPersonero" :value="true" /><span class="mr-2"></span>Personero</label>
                    <div v-if="actual.t3QuienPresentoImpugnacionPersonero === true" class="mt-2">
                      <label class="mb-1">Organizaciones políticas de los personeros:</label>
                      <div class="card-body py-0">
                        <table class="table mb-0">
                          <tbody>
                            <tr v-for="(item, index) in actual.itemsT3QuienPresentoImpugnacionPersonero" :key="'t3imp-' + index">
                              <td><img class="symbol-label" :src="getImagenPartidoPolitico(item.organizacionPoliticaParamId)" style="width:40px;height:auto;" /></td>
                              <td class="w-75">
                                <select class="form-control" v-model="item.organizacionPoliticaParamId">
                                  <option :value="null">- Seleccione organización -</option>
                                  <optgroup label="Partidos Políticos">
                                    <option v-for="partido in partidosNacionales" :key="partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                  </optgroup>
                                  <!-- <optgroup label="Movimientos Regionales">
                                    <option v-for="partido in partidosRegionales" :key="'mr-' + partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                  </optgroup> -->
                                </select>
                                <input type="number" min="1" max="99" class="form-control mt-2 w-50" v-model="item.numero" placeholder="Cantidad..." />
                              </td>
                              <td><a href="#" class="btn btn-outline-secondary" @click.prevent="deleteItemPersonero(actual.itemsT3QuienPresentoImpugnacionPersonero, item)"><i class="fa fa-trash p-0 text-danger"></i></a></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <a href="#" class="btn btn-secondary btn-sm" @click.prevent="addItemPersonero(actual.itemsT3QuienPresentoImpugnacionPersonero)"><i class="fa fa-plus"></i> Agregar</a>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">4.3. ¿Se presenciaron altercados, discusiones o actos de violencia durante el escrutinio?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3AltercadosODiscusionDuranteEscrutinio = true" class="btn" :class="[actual.t3AltercadosODiscusionDuranteEscrutinio === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3AltercadosODiscusionDuranteEscrutinio = false" class="btn" :class="[actual.t3AltercadosODiscusionDuranteEscrutinio === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t3AltercadosODiscusionDuranteEscrutinio === true" v-model="actual.t3AltercadosODiscusionDuranteEscrutinioDetalle" class="form-control mt-2" type="text" placeholder="Especifique..." required></textarea>
                  </div>
                </div>
              </div>

              <!-- V. PERSONEROS -->
              <div class="my-5">
                <h3 class=" text-dark font-weight-bold mb-10">V. Personeros</h3>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">5.1. ¿Hay presencia de personeros en la mesa de votación?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3PresenciaPersonerosMesa = true" class="btn" :class="[actual.t3PresenciaPersonerosMesa === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3PresenciaPersonerosMesa = false" class="btn" :class="[actual.t3PresenciaPersonerosMesa === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t3PresenciaPersonerosMesa === true" class="mt-2">
                      <label class="mb-1">Número total de personeros:</label>
                      <input type="number" class="form-control mb-2" v-model="actual.t3PresenciaPersonerosMesaCantidad" placeholder="Cantidad total..." />
                      <label class="mb-1">Cuántos y de qué partido:</label>
                      <div class="card-body py-0">
                        <table class="table mb-0">
                          <tbody>
                            <tr v-for="(item, index) in actual.itemsPersonerosMesaT3" :key="'t3mesa-' + index">
                              <td><img class="symbol-label" :src="getImagenPartidoPolitico(item.organizacionPoliticaParamId)" style="width:40px;height:auto;" /></td>
                              <td class="w-75">
                                <select class="form-control" v-model="item.organizacionPoliticaParamId">
                                  <option :value="null">- Seleccione organización -</option>
                                  <optgroup label="Partidos Políticos">
                                    <option v-for="partido in partidosNacionales" :key="partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                  </optgroup>
                                  <!-- <optgroup label="Movimientos Regionales">
                                    <option v-for="partido in partidosRegionales" :key="'mr-' + partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                  </optgroup> -->
                                </select>
                                <input type="number" min="1" max="99" class="form-control mt-2 w-50" v-model="item.numero" placeholder="Cantidad..." />
                              </td>
                              <td><a href="#" class="btn btn-outline-secondary" @click.prevent="deleteItemPersonero(actual.itemsPersonerosMesaT3, item)"><i class="fa fa-trash p-0 text-danger"></i></a></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <a href="#" class="btn btn-secondary btn-sm" @click.prevent="addItemPersonero(actual.itemsPersonerosMesaT3)"><i class="fa fa-plus"></i> Agregar</a>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">5.2. ¿Los/las personeros/as presentes pudieron observar el procedimiento de conteo de votos?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3PresenciaPersonerosObservaronConteo = true" class="btn" :class="[actual.t3PresenciaPersonerosObservaronConteo === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3PresenciaPersonerosObservaronConteo = false" class="btn" :class="[actual.t3PresenciaPersonerosObservaronConteo === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t3PresenciaPersonerosObservaronConteo === false" v-model="actual.t3PresenciaPersonerosObservaronConteoDetalle" class="form-control mt-2" type="text" placeholder="Especifique..." required></textarea>
                  </div>
                </div>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">5.3. ¿Se restringió la participación de algún personero durante el escrutinio?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3SeRestringioParticipacionPersonero = true" class="btn" :class="[actual.t3SeRestringioParticipacionPersonero === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3SeRestringioParticipacionPersonero = false" class="btn" :class="[actual.t3SeRestringioParticipacionPersonero === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t3SeRestringioParticipacionPersonero === true">
                      <div class="mt-2 mb-2">
                        <label class="mb-1">Organizaciones políticas a las que se restringió:</label>
                        <div class="card-body py-0">
                          <table class="table mb-0">
                            <tbody>
                              <tr v-for="(item, index) in actual.itemsT3SeRestringioParticipacionPersonero" :key="'t3res-' + index">
                                <td><img class="symbol-label" :src="getImagenPartidoPolitico(item.organizacionPoliticaParamId)" style="width:40px;height:auto;" /></td>
                                <td class="w-75">
                                  <select class="form-control" v-model="item.organizacionPoliticaParamId">
                                    <option :value="null">- Seleccione organización -</option>
                                    <optgroup label="Partidos Políticos">
                                      <option v-for="partido in partidosNacionales" :key="partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                    </optgroup>
                                    <!-- <optgroup label="Movimientos Regionales">
                                      <option v-for="partido in partidosRegionales" :key="'mrr-' + partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                    </optgroup> -->
                                  </select>
                                  <input type="number" min="1" max="99" class="form-control mt-2 w-50" v-model="item.numero" placeholder="Cantidad..." />
                                </td>
                                <td><a href="#" class="btn btn-outline-secondary" @click.prevent="deleteItemPersonero(actual.itemsT3SeRestringioParticipacionPersonero, item)"><i class="fa fa-trash p-0 text-danger"></i></a></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <a href="#" class="btn btn-secondary btn-sm" @click.prevent="addItemPersonero(actual.itemsT3SeRestringioParticipacionPersonero)"><i class="fa fa-plus"></i> Agregar</a>
                      </div>
                      <table class="table mb-0 mt-2">
                        <tbody>
                          <tr>
                            <td class="px-0">
                              <label class="checkbox checkbox-primary checkbox-lg">
                                <input type="checkbox" v-model="actual.t3SeRestringioParticipacionPersoneroPorAforo" :value="true" />
                                <span class="mr-2"></span>Por aforo</label>
                            </td>
                          </tr>
                          <tr>
                            <td class="px-0">
                              <label class="checkbox checkbox-primary checkbox-lg">
                                <input type="checkbox" v-model="actual.t3SeRestringioParticipacionPersoneroPorAlteracionOrden" :value="true" />
                                <span class="mr-2"></span>Por alteración del orden</label>
                            </td>
                          </tr>
                          <tr>
                            <td class="px-0 border-bottom">
                              <label class="checkbox checkbox-primary checkbox-lg">
                                <input type="checkbox" v-model="actual.t3SeRestringioParticipacionPersoneroPorOtro" :value="true" />
                                <span class="mr-2"></span>Otro</label>
                              <textarea class="form-control mt-2" v-if="actual.t3SeRestringioParticipacionPersoneroPorOtro == true" v-model="actual.t3SeRestringioParticipacionPersoneroPorOtroDetalle" type="text" placeholder="Especifique el motivo..." required></textarea>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">5.4. ¿Los personeros tuvieron la oportunidad de observar el acta electoral para realizar sus impugnaciones?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3PersonerosPudieronObservarActaElectoral = true" class="btn" :class="[actual.t3PersonerosPudieronObservarActaElectoral === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3PersonerosPudieronObservarActaElectoral = false" class="btn" :class="[actual.t3PersonerosPudieronObservarActaElectoral === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t3PersonerosPudieronObservarActaElectoral === false" v-model="actual.t3PersonerosPudieronObservarActaElectoralDetalle" class="form-control mt-2" type="text" placeholder="Especifique..." required></textarea>
                  </div>
                </div>
              </div>

            </div>
            <div class="col-xl-2"></div>

            <div v-if="eventosActualizacion.length > 0" v-html="eventosActualizacion"></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style scoped>
.table-hover tbody tr:hover {
  background-color: #f9f9f9;
}
</style>

<script>
import Swal from "sweetalert2";

export default {
  name: "ficha-turno-3-mesa-2026",
  components: {},
  props: {
    mesaVotacionId: {
      type: Number,
    },
    localVotacionId: {
      type: Number,
    },
    procesoElectoralId: {
      type: Number,
    },
    expandirContenido: {
      type: Boolean,
    },
    intervaloAutoGuardado: {
      type: Number,
    },
  },
  data: () => ({
    finalizado: false,
    auth: {
      autorizadoEdicionTurno: null,
      mensajeNoAutorizadoEdicionTurno: null,
      puedeCambiarEstadoFinalizado: null,
      puedeEditarTurno: null,
      puedeVisualizarTurno: null,
      puedeFinalizarTurno: null,
      puedeReanudarTurno: null,
      fechaInicioTurno: null,
      fechaFinTurno: null,
      fechaInicioEdicionTurno: null,
      fechaFinEdicionTurno: null,
    },
    ui: {
      colLeftClass: "col-sm-12 col-md-5",
      colRightClass: "col-sm-12 col-md-7",
      estaGuardando: false,
      estaCargandoDatos: false,
      tieneCargaInicial: false,
    },
    temporizadorGuardado: null,
    eventosActualizacion: [],
    numeroMesaEsperado: null,
    actual: {
      t3NumeroMesa: null,
      t3ConteoFirmasOHuellasCoincideActaSufragio: null,
      t3ConteoFirmasOHuellasCoincideActaSufragioDetalle: null,
      t3AnforaFueVerificadaAntesApertura: null,
      t3AnforaFueVerificadaAntesAperturaDetalle: null,
      t3AnforaSeAbrioEnPresenciaAsistentes: null,
      t3AnforaSeAbrioEnPresenciaAsistentesDetalle: null,
      t3ConteoCedulasCorrecto: null,
      t3ConteoCedulasCorrectoDetalle: null,
      t3AsignacionVotosCorrectaActas: null,
      t3AsignacionVotosCorrectaActasDetalle: null,
      t3MiembrosMesaConformesCifrasActa: null,
      t3MiembrosMesaConformesCifrasActaDetalle: null,
      t3CartelResultadosPublicadoAfueraAula: null,
      t3CartelResultadosPublicadoAfueraAulaDetalle: null,
      t3SePresentoImpugnacion: null,
      t3SePresentoImpugnacionDetalle: null,
      t3QuienPresentoImpugnacionMiembroMesa: null,
      t3QuienPresentoImpugnacionPersonero: null,
      t3QuienPresentoImpugnacionPersoneroOrganizacionParamId: null,
      itemsT3QuienPresentoImpugnacionPersonero: [],
      t3AltercadosODiscusionDuranteEscrutinio: null,
      t3AltercadosODiscusionDuranteEscrutinioDetalle: null,
      t3PresenciaPersonerosMesa: null,
      t3PresenciaPersonerosMesaCantidad: null,
      itemsPersonerosMesaT3: [],
      t3PresenciaPersonerosObservaronConteo: null,
      t3PresenciaPersonerosObservaronConteoDetalle: null,
      t3SeRestringioParticipacionPersonero: null,
      t3SeRestringioOrganizacionesIds: [],
      itemsT3SeRestringioParticipacionPersonero: [],
      t3SeRestringioParticipacionPersoneroPorAforo: null,
      t3SeRestringioParticipacionPersoneroPorAlteracionOrden: null,
      t3SeRestringioParticipacionPersoneroPorOtro: null,
      t3SeRestringioParticipacionPersoneroPorOtroDetalle: null,
      t3PersonerosPudieronObservarActaElectoral: null,
      t3PersonerosPudieronObservarActaElectoralDetalle: null,
    },
    partidos: [],
    guardado: {
      t3NumeroMesa: null,
      t3ConteoFirmasOHuellasCoincideActaSufragio: null,
      t3ConteoFirmasOHuellasCoincideActaSufragioDetalle: null,
      t3AnforaFueVerificadaAntesApertura: null,
      t3AnforaFueVerificadaAntesAperturaDetalle: null,
      t3AnforaSeAbrioEnPresenciaAsistentes: null,
      t3AnforaSeAbrioEnPresenciaAsistentesDetalle: null,
      t3ConteoCedulasCorrecto: null,
      t3ConteoCedulasCorrectoDetalle: null,
      t3AsignacionVotosCorrectaActas: null,
      t3AsignacionVotosCorrectaActasDetalle: null,
      t3MiembrosMesaConformesCifrasActa: null,
      t3MiembrosMesaConformesCifrasActaDetalle: null,
      t3CartelResultadosPublicadoAfueraAula: null,
      t3CartelResultadosPublicadoAfueraAulaDetalle: null,
      t3SePresentoImpugnacion: null,
      t3SePresentoImpugnacionDetalle: null,
      t3QuienPresentoImpugnacionMiembroMesa: null,
      t3QuienPresentoImpugnacionPersonero: null,
      t3QuienPresentoImpugnacionPersoneroOrganizacionParamId: null,
      itemsT3QuienPresentoImpugnacionPersonero: [],
      t3AltercadosODiscusionDuranteEscrutinio: null,
      t3AltercadosODiscusionDuranteEscrutinioDetalle: null,
      t3PresenciaPersonerosMesa: null,
      t3PresenciaPersonerosMesaCantidad: null,
      itemsPersonerosMesaT3: [],
      t3PresenciaPersonerosObservaronConteo: null,
      t3PresenciaPersonerosObservaronConteoDetalle: null,
      t3SeRestringioParticipacionPersonero: null,
      t3SeRestringioOrganizacionesIds: [],
      itemsT3SeRestringioParticipacionPersonero: [],
      t3SeRestringioParticipacionPersoneroPorAforo: null,
      t3SeRestringioParticipacionPersoneroPorAlteracionOrden: null,
      t3SeRestringioParticipacionPersoneroPorOtro: null,
      t3SeRestringioParticipacionPersoneroPorOtroDetalle: null,
      t3PersonerosPudieronObservarActaElectoral: null,
      t3PersonerosPudieronObservarActaElectoralDetalle: null,
    },
  }),
  computed: {
    partidosNacionales: function () { return (this.partidos || []).filter(function (p) { return p.regionId == 0; }); },
    partidosRegionales: function () { return (this.partidos || []).filter(function (p) { return p.regionId != 0; }); },
    isDirty: function () {
      return JSON.stringify(this.actual) != JSON.stringify(this.guardado);
    },
    mostrarDetalleFicha: function () {
      if (!this.ui.tieneCargaInicial) return false;
      if (!this.auth.autorizadoEdicionTurno) return false;

      return true;
    },
  },
  methods: {
    inicializarGuardado: function () {
      // var vm = this;
      // clearTimeout(this.temporizadorGuardado);
      // this.temporizadorGuardado = setTimeout(function() {
      //   if (vm.isDirty) {
      //     vm.doGuardado();
      //   }
      // }, this.intervaloAutoGuardado);
    },
    doCargarFicha: async function () {
      this.ui.estaCargandoDatos = true;
      var model = {
        mesaVotacionId: this.mesaVotacionId,
        procesoElectoralId: this.procesoElectoralId,
      };

      await this.$http.post(this.apiRoute("Sheet", "GetFichaMesaTurnoTres"), model).then(function (response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          var ficha = response.body.data.ficha;

          var tempActual = this.cloneObject(this.actual);
          var tempGuardado = this.cloneObject(this.guardado);

          tempActual.t3NumeroMesa = this.actualizarBaseDiferente("t3NumeroMesa", tempActual, tempGuardado, ficha);
          tempActual.t3ConteoFirmasOHuellasCoincideActaSufragio = this.actualizarBaseDiferente("t3ConteoFirmasOHuellasCoincideActaSufragio", tempActual, tempGuardado, ficha);
          tempActual.t3ConteoFirmasOHuellasCoincideActaSufragioDetalle = this.actualizarBaseDiferente("t3ConteoFirmasOHuellasCoincideActaSufragioDetalle", tempActual, tempGuardado, ficha);
          tempActual.t3AnforaFueVerificadaAntesApertura = this.actualizarBaseDiferente("t3AnforaFueVerificadaAntesApertura", tempActual, tempGuardado, ficha);
          tempActual.t3AnforaFueVerificadaAntesAperturaDetalle = this.actualizarBaseDiferente("t3AnforaFueVerificadaAntesAperturaDetalle", tempActual, tempGuardado, ficha);
          tempActual.t3AnforaSeAbrioEnPresenciaAsistentes = this.actualizarBaseDiferente("t3AnforaSeAbrioEnPresenciaAsistentes", tempActual, tempGuardado, ficha);
          tempActual.t3AnforaSeAbrioEnPresenciaAsistentesDetalle = this.actualizarBaseDiferente("t3AnforaSeAbrioEnPresenciaAsistentesDetalle", tempActual, tempGuardado, ficha);
          tempActual.t3ConteoCedulasCorrecto = this.actualizarBaseDiferente("t3ConteoCedulasCorrecto", tempActual, tempGuardado, ficha);
          tempActual.t3ConteoCedulasCorrectoDetalle = this.actualizarBaseDiferente("t3ConteoCedulasCorrectoDetalle", tempActual, tempGuardado, ficha);
          tempActual.t3AsignacionVotosCorrectaActas = this.actualizarBaseDiferente("t3AsignacionVotosCorrectaActas", tempActual, tempGuardado, ficha);
          tempActual.t3AsignacionVotosCorrectaActasDetalle = this.actualizarBaseDiferente("t3AsignacionVotosCorrectaActasDetalle", tempActual, tempGuardado, ficha);
          tempActual.t3MiembrosMesaConformesCifrasActa = this.actualizarBaseDiferente("t3MiembrosMesaConformesCifrasActa", tempActual, tempGuardado, ficha);
          tempActual.t3MiembrosMesaConformesCifrasActaDetalle = this.actualizarBaseDiferente("t3MiembrosMesaConformesCifrasActaDetalle", tempActual, tempGuardado, ficha);
          tempActual.t3CartelResultadosPublicadoAfueraAula = this.actualizarBaseDiferente("t3CartelResultadosPublicadoAfueraAula", tempActual, tempGuardado, ficha);
          tempActual.t3CartelResultadosPublicadoAfueraAulaDetalle = this.actualizarBaseDiferente("t3CartelResultadosPublicadoAfueraAulaDetalle", tempActual, tempGuardado, ficha);
          tempActual.t3SePresentoImpugnacion = this.actualizarBaseDiferente("t3SePresentoImpugnacion", tempActual, tempGuardado, ficha);
          tempActual.t3SePresentoImpugnacionDetalle = this.actualizarBaseDiferente("t3SePresentoImpugnacionDetalle", tempActual, tempGuardado, ficha);
          tempActual.t3QuienPresentoImpugnacionMiembroMesa = this.actualizarBaseDiferente("t3QuienPresentoImpugnacionMiembroMesa", tempActual, tempGuardado, ficha);
          tempActual.t3QuienPresentoImpugnacionPersonero = this.actualizarBaseDiferente("t3QuienPresentoImpugnacionPersonero", tempActual, tempGuardado, ficha);
          tempActual.t3QuienPresentoImpugnacionPersoneroOrganizacionParamId = this.actualizarBaseDiferente("t3QuienPresentoImpugnacionPersoneroOrganizacionParamId", tempActual, tempGuardado, ficha);
          tempActual.itemsT3QuienPresentoImpugnacionPersonero = this.actualizarBaseDiferente("itemsT3QuienPresentoImpugnacionPersonero", tempActual, tempGuardado, ficha);
          if (!tempActual.itemsT3QuienPresentoImpugnacionPersonero || !Array.isArray(tempActual.itemsT3QuienPresentoImpugnacionPersonero)) tempActual.itemsT3QuienPresentoImpugnacionPersonero = [];
          tempActual.t3AltercadosODiscusionDuranteEscrutinio = this.actualizarBaseDiferente("t3AltercadosODiscusionDuranteEscrutinio", tempActual, tempGuardado, ficha);
          tempActual.t3AltercadosODiscusionDuranteEscrutinioDetalle = this.actualizarBaseDiferente("t3AltercadosODiscusionDuranteEscrutinioDetalle", tempActual, tempGuardado, ficha);
          tempActual.t3PresenciaPersonerosMesa = this.actualizarBaseDiferente("t3PresenciaPersonerosMesa", tempActual, tempGuardado, ficha);
          tempActual.t3PresenciaPersonerosMesaCantidad = this.actualizarBaseDiferente("t3PresenciaPersonerosMesaCantidad", tempActual, tempGuardado, ficha);
          tempActual.itemsPersonerosMesaT3 = (ficha.itemsPersonerosMesaT3 || []).map(function (x) { return { organizacionPoliticaParamId: x.organizacionPoliticaParamId, numero: x.numero }; });
          tempActual.t3PresenciaPersonerosObservaronConteo = this.actualizarBaseDiferente("t3PresenciaPersonerosObservaronConteo", tempActual, tempGuardado, ficha);
          tempActual.t3PresenciaPersonerosObservaronConteoDetalle = this.actualizarBaseDiferente("t3PresenciaPersonerosObservaronConteoDetalle", tempActual, tempGuardado, ficha);
          tempActual.t3SeRestringioParticipacionPersonero = this.actualizarBaseDiferente("t3SeRestringioParticipacionPersonero", tempActual, tempGuardado, ficha);
          tempActual.itemsT3SeRestringioParticipacionPersonero = this.actualizarBaseDiferente("itemsT3SeRestringioParticipacionPersonero", tempActual, tempGuardado, ficha);
          if (!tempActual.itemsT3SeRestringioParticipacionPersonero || !Array.isArray(tempActual.itemsT3SeRestringioParticipacionPersonero)) tempActual.itemsT3SeRestringioParticipacionPersonero = [];
          tempActual.t3SeRestringioParticipacionPersoneroPorAforo = this.actualizarBaseDiferente("t3SeRestringioParticipacionPersoneroPorAforo", tempActual, tempGuardado, ficha);
          tempActual.t3SeRestringioParticipacionPersoneroPorAlteracionOrden = this.actualizarBaseDiferente("t3SeRestringioParticipacionPersoneroPorAlteracionOrden", tempActual, tempGuardado, ficha);
          tempActual.t3SeRestringioParticipacionPersoneroPorOtro = this.actualizarBaseDiferente("t3SeRestringioParticipacionPersoneroPorOtro", tempActual, tempGuardado, ficha);
          tempActual.t3SeRestringioParticipacionPersoneroPorOtroDetalle = this.actualizarBaseDiferente("t3SeRestringioParticipacionPersoneroPorOtroDetalle", tempActual, tempGuardado, ficha);
          tempActual.t3PersonerosPudieronObservarActaElectoral = this.actualizarBaseDiferente("t3PersonerosPudieronObservarActaElectoral", tempActual, tempGuardado, ficha);
          tempActual.t3PersonerosPudieronObservarActaElectoralDetalle = this.actualizarBaseDiferente("t3PersonerosPudieronObservarActaElectoralDetalle", tempActual, tempGuardado, ficha);

          this.actual = this.cloneObject(tempActual);
          this.guardado = this.cloneObject(this.actual);
          this.auth = response.body.data.auth;
          this.numeroMesaEsperado = response.body.data.numeroMesaEsperado || "";
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.ui.tieneCargaInicial = true;
      this.ui.estaCargandoDatos = false;
    },
    actualizarBaseDiferente: function (propiedad, fichaActual, fichaGuardado, fichaActualizada) {
      var valorActual = JSON.stringify(fichaActual[propiedad]);
      var valorGuardado = JSON.stringify(fichaGuardado[propiedad]);
      var valorActualizado = JSON.stringify(fichaActualizada[propiedad]);

      if (valorActual == valorGuardado && valorGuardado != valorActualizado) {
        return fichaActualizada[propiedad];
      } else {
        return fichaActual[propiedad];
      }
    },
    doGuardado: async function (omitirNotificacion) {
      if (this.ui.estaGuardando) return;

      var numeroMesaIngresado = (this.actual.t3NumeroMesa != null ? String(this.actual.t3NumeroMesa) : "").trim();
      if (!numeroMesaIngresado) {
        if (omitirNotificacion != true) {
          Swal.fire({
            icon: "warning",
            title: "Número de mesa requerido",
            text: "Debe ingresar el número de mesa antes de guardar.",
          });
        }
        return false;
      }
      var numeroEsperado = (this.numeroMesaEsperado != null ? String(this.numeroMesaEsperado) : "").trim();
      if (numeroEsperado && numeroMesaIngresado !== numeroEsperado) {
        if (omitirNotificacion != true) {
          Swal.fire({
            icon: "error",
            title: "Número de mesa incorrecto",
            text: "El número de mesa ingresado no corresponde a la mesa que se está evaluando. Se espera la mesa N° " + numeroEsperado + ".",
          });
        }
        return false;
      }

      if (!this.isFormValid("frm-mesa-turno-3")) {
        if (omitirNotificacion != true) {
          this.$bvToast.toast("Hay campos con valores incorrectos. Revise los datos ingresados.", {
            title: "Turno 3 - Mesa",
            autoHideDelay: 5000,
            variant: "warning",
            appendToast: false,
            solid: true,
          });
          return false;
        }
      }

      var actualClone = this.cloneObject(this.actual);

      var model = this.cloneObject(this.actual);
      model.mesaVotacionId = this.mesaVotacionId;
      model.procesoElectoralId = this.procesoElectoralId;
      delete model.t3SeRestringioOrganizacionesIds;

      var guardadoExistoso = false;
      this.ui.estaGuardando = true;
      await this.$http.post(this.apiRoute("Sheet", "EditFichaMesaTurnoTres"), model).then(function (response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          this.guardado = actualClone;

          if (omitirNotificacion != true) {
            this.$bvToast.toast("Los cambios se han guardado correctamente.", {
              title: "Turno 3 - Mesa",
              autoHideDelay: 5000,
              variant: "success",
              appendToast: false,
              solid: true,
            });
          }
          guardadoExistoso = true;

          this.doCargarFicha();

          this.$notifyHub.notificarCambioFicha(this.procesoElectoralId, this.mesaVotacionId, 3);
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.ui.estaGuardando = false;
      return guardadoExistoso;
    },
    fetchPartidosPoliticos: function () {
      var self = this;
      if (!this.localVotacionId) return;
      this.$http.get(this.apiRoute("Parameter", "ListParametrosPoliticos"), { params: { Id: this.localVotacionId } }).then(function (response) {
        var parameterResponse = response.body && response.body.data ? response.body.data : [];
        self.partidos = parameterResponse;
      });
    },
    addItemPersonero: function (arr) {
      if (!arr) return;
      arr.push({ organizacionPoliticaParamId: null, numero: null });
    },
    deleteItemPersonero: function (arr, item) {
      if (!arr) return;
      var idx = arr.indexOf(item);
      if (idx >= 0) arr.splice(idx, 1);
    },
    getImagenPartidoPolitico: function (partidoPoliticoParamId) {
      var partido = this.partidos.find(function (x) { return x.parametroId == partidoPoliticoParamId; });
      var imagen = partido ? partido.imagen : null;
      if (!imagen) imagen = "app-partidos/_no-image.png";
      return this.apiResource(imagen);
    },
    doToggleFinalizado: async function () {
      if (this.finalizado) {
        if (!(await this.sweetConfirm("¿Desea desbloquear esta sección?"))) {
          return;
        }
        this.finalizado = !this.finalizado;
      } else {
        if (!(await this.sweetConfirm("¿Desea finalizar esta sección?"))) {
          return;
        }
        this.finalizado = !this.finalizado;
      }
    },
  },
  watch: {
    isDirty: function (newValue, oldValue) {
      // if (newValue && this.intervaloAutoGuardado) {
      //   this.inicializarGuardado();
      // } else {
      //   clearTimeout(this.temporizadorGuardado);
      // }
    },
    actual: {
      deep: true,
      handler() {
        // if (this.intervaloAutoGuardado && !this.ui.estaCargandoDatos) {
        //   this.inicializarGuardado();
        // }
      },
    },
  },
  mounted: function () {
    this.initParsley();
    this.fetchPartidosPoliticos();
    this.doCargarFicha();
  },
  destoyed: function () {
    //clearTimeout(this.temporizadorGuardado);
  },
};
</script>
